import React from 'react';

import FormWrapper from 'Components-redesign/FormWrapper';
import { useI18n } from 'Hooks';
import {
  getCompany_company_categories as Category,
  getCompany_company_courseTypes as CourseType,
} from 'Scenes-redesign/PIM/__queries__';
import CategoryForm from 'Scenes-redesign/PIM/Forms/CategoryForm';
import { ActivatedFeatures } from 'Scenes-redesign/PIM/utils';

interface Props {
  categories: Category[];
  coursetypes: CourseType[];
  closeModal: () => void;
  handleFormSuccess: (value?: any) => void;
  activatedFeatures: ActivatedFeatures;
}

const CreateCategory = ({
  categories,
  coursetypes,
  closeModal,
  handleFormSuccess,
  activatedFeatures,
}: Props) => {
  const { t } = useI18n();

  return (
    <FormWrapper
      title={t('PIM.CreateCategory')}
      description={t('PIM.CategoryHeaderDescription')}
      closeModal={closeModal}>
      <CategoryForm
        categories={categories}
        coursetypes={coursetypes}
        onFormSuccess={handleFormSuccess}
        activatedFeatures={activatedFeatures}
      />
    </FormWrapper>
  );
};

export default CreateCategory;
